<template>
  <div>
    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/order/getFeedback"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="car_number">
          <Input type="text" v-model="searchData.car_number" placeholder="车牌号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="car_number">
          <Select v-model="searchData.station_id" :filterable="true" placeholder="站点">
            <Option v-for="(item,key) in stations" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>

      </template>

    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";

  export default {
    name: "lists",
    components:{pageTable},
    data() {
      return {
        searchData: {
          car_number: '',
          station_id:''
        },
        tableColumn: [
          {title: '电话',key: 'user_mobile',align: "center"},
          {title: '姓名',key: 'user_name',align: "center"},
          {title: '车牌',key: 'car_number',align: "center"},
          {title:'油站',key:'gas_name',align:'center'},
          {title:'数量',key:'litre_num',align:'center'},
          {title:'评价',key:'feedback_satisfaction',align:'center'},
          {title:'评价内容',key:'feedback_content',align:'left'},
          {title:'订单时间',key:'create_time',align:'center',width:170},
          {title:'评价时间',key:'feedback_time',align:'center',width:170},
        ],
        stations:[],
      }
    },
    methods: {

    },
    mounted() {
      this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['oil_station','companys']}).then((res)=>{
        this.stations = res.data.oil_station
        this.companys = res.data.companys
      })
    },
  }
</script>

<style scoped>

</style>
